import React from 'react'
import { Card } from 'antd'
import { Column } from '@ant-design/plots'
import type { CategoryData } from '../types/analytics.types'

interface CategoryChartProps {
    data: CategoryData[]
}

export const CategoryChart: React.FC<CategoryChartProps> = ({ data }) => {
    const config = {
        data,
        xField: 'category',
        yField: 'orders',
        label: {
            position: 'top',
            style: {
                fill: '#000',
            },
        },
        columnStyle: {
            fill: '#7c3aed',
        },
    } as any

    return (
        <Card title="Orders by Category">
            <Column {...config} />
        </Card>
    )
}
